import { action } from 'easy-peasy';
import { IActionSetCarePlanMedicalNotes } from '../types';

const setCarePlanMedicalNote: IActionSetCarePlanMedicalNotes = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanMedicalNote;
